import {
  faMagnifyingGlassPlus,
  faFileLines,
  faPenToSquare,
  faTextWidth,
  faMicrochip,
  faLightbulb,
  faListUl,
  faFaceSmile,
  faSuitcase,
  faWandMagicSparkles,
  faMessageImage,
  faMessageText,
} from '@fortawesome/pro-regular-svg-icons';
import {faArrowUpToBracket, faLanguage} from '@fortawesome/pro-solid-svg-icons';
import {TextEditCommands} from '@snapper/ai-core';

export const RTL_LANGUAGES = [
  'arabic',
  'hebrew',
  'urdu',
  'persian'
];

export const TRANSLATION_LANGUAGES = [
  {id: 'translate-afrikaans', title: 'Afrikaans'},
  {id: 'translate-albanian', title: 'Albanian'},
  {id: 'translate-arabic', title: 'Arabic'},
  {id: 'translate-azerbaijani', title: 'Azerbaijani'},
  {id: 'translate-belarusian', title: 'Belarusian'},
  {id: 'translate-bengali', title: 'Bengali'},
  {id: 'translate-bosnian', title: 'Bosnian'},
  {id: 'translate-bulgarian', title: 'Bulgarian'},
  {id: 'translate-burmese', title: 'Burmese'},
  {id: 'translate-chinese', title: 'Chinese'},
  {id: 'translate-croatian', title: 'Croatian'},
  {id: 'translate-czech', title: 'Czech'},
  {id: 'translate-danish', title: 'Danish'},
  {id: 'translate-dutch', title: 'Dutch'},
  {id: 'translate-english', title: 'English'},
  {id: 'translate-estonian', title: 'Estonian'},
  {id: 'translate-filipino', title: 'Filipino'},
  {id: 'translate-finnish', title: 'Finnish'},
  {id: 'translate-french', title: 'French'},
  {id: 'translate-frisian', title: 'Frisian'},
  {id: 'translate-galician', title: 'Galician'},
  {id: 'translate-georgian', title: 'Georgian'},
  {id: 'translate-german', title: 'German'},
  {id: 'translate-greek', title: 'Greek'},
  {id: 'translate-guarani', title: 'Guarani'},
  {id: 'translate-gujarati', title: 'Gujarati'},
  {id: 'translate-hebrew', title: 'Hebrew'},
  {id: 'translate-hindi', title: 'Hindi'},
  {id: 'translate-hungarian', title: 'Hungarian'},
  {id: 'translate-icelandic', title: 'Icelandic'},
  {id: 'translate-indonesian', title: 'Indonesian'},
  {id: 'translate-italian', title: 'Italian'},
  {id: 'translate-japanese', title: 'Japanese'},
  {id: 'translate-kannada', title: 'Kannada'},
  {id: 'translate-khmer', title: 'Khmer'},
  {id: 'translate-korean', title: 'Korean'},
  {id: 'translate-kyrgyz', title: 'Kyrgyz'},
  {id: 'translate-lao', title: 'Lao'},
  {id: 'translate-latvian', title: 'Latvian'},
  {id: 'translate-lingala', title: 'Lingala'},
  {id: 'translate-lithuanian', title: 'Lithuanian'},
  {id: 'translate-macedonian', title: 'Macedonian'},
  {id: 'translate-malay', title: 'Malay'},
  {id: 'translate-malayalam', title: 'Malayalam'},
  {id: 'translate-marathi', title: 'Marathi'},
  {id: 'translate-nepali', title: 'Nepali'},
  {id: 'translate-norsk_bokmal', title: 'Norwegian (Bokmål)'},
  {id: 'translate-norsk_nynorsk', title: 'Norwegian (Nynorsk)'},
  {id: 'translate-persian', title: 'Persian'},
  {id: 'translate-polish', title: 'Polish'},
  {id: 'translate-portuguese', title: 'Portuguese'},
  {id: 'translate-punjabi', title: 'Punjabi'},
  {id: 'translate-romanian', title: 'Romanian'},
  {id: 'translate-russian', title: 'Russian'},
  {id: 'translate-slovak', title: 'Slovak'},
  {id: 'translate-slovenian', title: 'Slovenian'},
  {id: 'translate-spanish', title: 'Spanish'},
  {id: 'translate-swahili', title: 'Swahili'},
  {id: 'translate-swedish', title: 'Swedish'},
  {id: 'translate-tagalog', title: 'Tagalog'},
  {id: 'translate-tamil', title: 'Tamil'},
  {id: 'translate-telugu', title: 'Telugu'},
  {id: 'translate-thai', title: 'Thai'},
  {id: 'translate-turkish', title: 'Turkish'},
  {id: 'translate-ukrainian', title: 'Ukrainian'},
  {id: 'translate-urdu', title: 'Urdu'},
  {id: 'translate-uzbek', title: 'Uzbek'},
  {id: 'translate-vietnamese', title: 'Vietnamese'},
  {id: 'translate-welsh', title: 'Welsh'},
  {id: 'translate-zulu', title: 'Zulu'},
];

export const AI_TEXT_MENU_ITEMS = [
  [
    {
      id: 'prompt-text',
      title: 'Generer tekst fra prompt',
      icon: faMessageText,
    },
  ],
  [
    {
      id: TextEditCommands.MoreDetails,
      title: 'Detaljer',
      icon: faMagnifyingGlassPlus, // Representerer å se nærmere eller utvide informasjon
    },
    {
      id: TextEditCommands.Summarize,
      title: 'Sammendrag',
      icon: faFileLines, // Symboliserer et dokument som er komprimert eller kortfattet
    },
    {
      id: TextEditCommands.Rewrite,
      title: 'Omskriv',
      icon: faPenToSquare, // Indikerer redigering eller omskriving av tekst
    },
    {
      id: TextEditCommands.LongerText,
      title: 'Lengre tekst',
      icon: faTextWidth, // Representerer utvidelse av tekst
    },
    {
      id: TextEditCommands.Technical,
      title: 'Teknisk',
      icon: faMicrochip, // Symboliserer teknologi, kompleksitet eller presisjon
    },
    {
      id: TextEditCommands.Creative,
      title: 'Kreativ',
      icon: faLightbulb, // Står for ideer, kreativitet eller innovasjon
    },
    {
      title: 'Translate',
      icon: faLanguage,
      items: [TRANSLATION_LANGUAGES],
    },
  ],
  [
    {
      id: TextEditCommands.BulletPoints,
      title: 'Punktliste',
      icon: faListUl, // Standardikon for punktlister
    },
  ],
  [
    {
      title: 'Endre tone of voice',
      items: [[
        {
          id: TextEditCommands.CasualTone,
          title: 'Vennlig tone',
          icon: faFaceSmile, // Formidler en vennlig eller avslappet tone
        },
        {
          id: TextEditCommands.FormalTone,
          title: 'Formell tone',
          icon: faSuitcase, // Assosieres med formalitet eller profesjonalitet
        },
      ]],
    },
  ],
];

export const AI_IMAGE_MENU_ITEMS = [
  [
    {
      id: 'generate-image',
      title: 'Generer bilde fra innhold',
      icon: faWandMagicSparkles,
    },
    {
      id: 'prompt-image',
      title: 'Generer bilde fra prompt',
      icon: faMessageImage,
    },
  ],
];

export const ADD_IMAGE_MENU_ITEMS = [
  AI_IMAGE_MENU_ITEMS[0], // Include the first row of AI_IMAGE_MENU_ITEMS
  [
    {
      id: 'choose-image',
      title: 'Velg/last opp bilde',
      icon: faArrowUpToBracket,
    },
  ],
];